export default __webpack_public_path__ + "static/media/photo2.cc1e4da0.jpg";